"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { mainNavItems, matchRoute } from "@/lib/navigation";

export function SiteTabBar() {
  const pathname = usePathname();
  if (pathname.startsWith("/admin") || pathname.startsWith("/chat")) return null;

  return (
    <nav
      aria-label="하단 탭 메뉴"
      className="fixed right-0 bottom-0 left-0 z-50 flex h-14 items-center justify-around border-t border-black/6 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl lg:hidden"
    >
      {mainNavItems
        .filter((item) => !item.desktopOnly)
        .map((tab) => {
          const Icon = tab.icon;
          const active = matchRoute(pathname, tab);
          return (
            <Link
              key={tab.href}
              href={tab.href}
              aria-current={active ? "page" : undefined}
              className={cn(
                "flex flex-col items-center gap-0.5 px-4 py-1.5 transition-colors",
                active ? "text-primary" : "text-gray-400",
              )}
            >
              <Icon className="h-[22px] w-[22px]" strokeWidth={1.8} />
              <span className="text-[10px] font-semibold tracking-tight">{tab.label}</span>
            </Link>
          );
        })}
    </nav>
  );
}
